<template>
	<div class="sidebar close bg-gradient-to-r from-cyan-500 to-blue-500">
		<div class="logo-details">
			<!-- <i class="fas fa-home fa-menu"></i> -->
			<img class="fa-menu" src="../assets/logo-picture.png" alt="" />
			<span class="logo-name">КазМунайГаз</span>
		</div>
		<ul class="nav-links">
			<li>
				<router-link :to="{ name: 'home' }">
					<i class="material-icons">home</i>
					<span class="link-name">Главная</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link class="link-name" :to="{ name: 'home' }" id="v-step-main">
							Главная
						</router-link>
					</li>
				</ul>
			</li>

			<li v-if="!this.$store.getters.isActiveAccount">
				<router-link :to="{ name: 'activate-profile' }">
					<i class="material-icons">home</i>
					<span class="link-name">Активация</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link
							class="link-name"
							:to="{ name: 'activate-profile' }"
						>
							Активация
						</router-link>
					</li>
				</ul>
			</li>

			<li v-if="USER.ouser.for_report">
				<div class="icon-link">
          <router-link :to="{ name: 'my-reports' }" id="v-step-0">
						<i class="material-icons">note_add</i>
						<span class="link-name">Отчеты</span>
          </router-link>
					<!-- <i class="material-icons">arrow_downward</i> -->
				</div>
				<ul class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500">
					<li><a class="link-name" href="#">Отчеты</a></li>
					<li
						v-if="
							isActiveAccount && accessLevel(USER.ouser.role, 1)
						"
					>
						<router-link :to="{ name: 'create-report' }">
							Формирование отчета
						</router-link>
					</li>
					<!-- <li
						v-if="
							isActiveAccount && accessLevel(USER.ouser.role, 3)
						"
					>
						<router-link :to="{ name: 'report-statuses' }">
							Статусы отчетов
						</router-link>
					</li> -->
					<li v-if="isActiveAccount">
						<router-link :to="{ name: 'my-reports' }">
							Мои отчеты металлолом
						</router-link>
					</li>
					<li v-if="isActiveAccount && !accessLevel(USER.ouser.role, 3)">
						<router-link :to="{ name: 'reports' }">
							Другие отчеты
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="USER.ouser.for_tmz">
				<div class="icon-link">
          <router-link :to="{ name: 'tmz-my-reports' }" id="v-step-1">
						<i class="material-icons">post_add</i>
						<span class="link-name">ТМЗ</span>
          </router-link>
					<i class="fas fa-arrow-down arrow"></i>
				</div>
				<ul class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500">
					<li><a class="link-name" href="#">ТМЗ</a></li>
					<li
						v-if="
							isActiveAccount && accessLevel(USER.ouser.role, 1)
						"
					>
						<router-link :to="{ name: 'create-tmz-step-first' }">
							Формирования ТМЗ
						</router-link>
					</li>
					<li v-if="isActiveAccount">
						<router-link :to="{ name: 'tmz-my-reports' }">
							Мои Отчеты ТМЗ
						</router-link>
					</li>
					<li v-if="isActiveAccount && !accessLevel(USER.ouser.role, 3)">
						<router-link :to="{ name: 'tmz-other-reports' }">
							Отчеты ТМЗ
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount && accessLevel(USER.ouser.role, 3)">
				<router-link :to="{ name: 'summary-table' }">
					<i class="material-icons">space_dashboard</i>
					<span class="link-name">Итоговая форма</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'summary-table' }">
							Итоговая форма
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount">
				<router-link :to="{ name: 'tmz-search' }" id="v-step-2">
					<i class="material-icons">saved_search</i>
					<span class="link-name">Поиск ТМЗ</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'tmz-search' }">
							Поиск ТМЗ
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount && accessLevel(USER.ouser.role, 3)">
				<router-link :to="{ name: 'tmz-search-kmg' }">
					<i class="material-icons">travel_explore</i>
					<span class="link-name">Поиск КМГ ТМЗ</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'tmz-search-kmg' }">
							Поиск КМГ ТМЗ
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount">
				<router-link :to="{ name: 'profile' }" id="v-step-4">
					<i class="material-icons">account_circle</i>
					<span class="link-name">Профиль</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'profile' }">
							Профиль
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount">
				<router-link :to="{ name: 'notification' }">
					<i class="material-icons">notifications_active</i>
					<span class="badge" v-if="this.GETCOUNTNOTIFICATIONS > 0">
						{{ this.GETCOUNTNOTIFICATIONS }}
					</span>
					<span class="link-name">Уведомления</span>
					<!-- <i>notifications_active</i> -->
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'notification' }">
							Уведомления
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount">
				<router-link :to="{ name: 'learning' }" id="v-step-5">
					<i class="material-icons">local_library</i>
					<span class="link-name">Обучение</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'learning' }">
							Обучение
						</router-link>
					</li>
				</ul>
			</li>
			<li v-if="isActiveAccount">
				<router-link :to="{ name: 'messenger' }" id="v-step-6">
					<i class="material-icons">question_answer</i>
					<span class="link-name">Чат</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'messenger' }">
							Чат
						</router-link>
					</li>
				</ul>
			</li>
			<li>
				<router-link :to="{ name: 'logout' }" id="v-step-7">
					<i class="material-icons">logout</i>
					<span class="link-name">Выйти</span>
				</router-link>
				<ul
					class="sub-menu bg-gradient-to-r from-cyan-500 to-blue-500 blank"
				>
					<li>
						<router-link :to="{ name: 'logout' }">
							Выйти
						</router-link>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['isActiveAccount', 'USER', 'GETCOUNTNOTIFICATIONS', 'createAllowed']),
	},
	methods: {
		openModal() {
			let body = document.body;
			body.classList.add('show-auth-modal', 'noscroll');
			this.showModal = !this.showModal;

			// Close modal if ESC key tapped
			body.addEventListener('keyup', e => {
				if (e.keyCode == 27) {
					this.closeModal();
				}
			});
		},
		accessLevel(roles, level) {
			if (roles) {
				let arr = Object.keys(
					JSON.parse(JSON.stringify(this.USER.ouser.role))
				);
				for (const role in arr) {
					if (roles[role].access_level === level) {
						return true;
					}
				}
				return false;
			}
			return false;
		},
		closeModal() {
			let body = document.body;
			body.classList.remove('show-auth-modal', 'noscroll');
		},
		getCountNotification() {
			this.$store.dispatch('getCountNotification');
		},
	},
	mounted() {
		let sidebar = document.querySelector('.sidebar');
		let arrow = document.querySelectorAll('.arrow');
		let icon = document.querySelector('.fa-menu');

		arrow.forEach(element => {
			element.addEventListener('click', e => {
				let arrowParent = e.target.parentElement.parentElement;
				arrowParent.classList.toggle('showMenu');
			});
		});

		icon.addEventListener('click', () => {
			sidebar.classList.toggle('close');
		});

		this.getCountNotification();
	},
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

.sidebar {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 260px;
	// background: #36429e;
	z-index: 100;
	transition: all 0.3s ease;
	font-family: 'Poppins', sans-serif;
}

.sidebar.close {
	width: 78px;
}

.sidebar.close .logo-details .logo-name {
	opacity: 0;
	pointer-events: none;
}

.logo-details {
	height: 60px;
	width: 100%;
	display: flex;
	align-items: center;
}

.logo-details img {
	font-size: 30px;
	color: #fff;
	height: 50px;
	min-width: 78px;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
}

.logo-details .logo-name {
	font-size: 22px;
	color: #fff;
	font-weight: 600;
	transition: all 0.3s ease;
	transition: 0.1s;
}

.nav-links {
	height: 100%;
	padding-top: 30px 0 150px 0;
	overflow: auto;
}

.nav-links {
	overflow: visible;
}

.nav-links::-webkit-scrollbar {
	display: none;
}

.nav-links li {
	position: relative;
	list-style: none;
}

.nav-links li:hover {
	// background: #98C1D9;
	// background: rgb(137, 194, 217, 0.7);

	list-style: none;
	transition: all 0.3s ease;
}

.nav-links li .icon-link {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.sidebar.close .nav-links li .icon-link {
	display: block;
}

.nav-links li i {
	height: 50px;
	min-width: 78px;
	text-align: center;
	line-height: 50px;
	color: #fff;
	font-size: 1.8rem;
	transition: all 0.3s ease;
	cursor: pointer;
}

.nav-links li.showMenu i.arrow {
	transform: rotate(-180deg);
}

.sidebar.close .nav-links i.arrow {
	display: none;
}

.nav-links li a {
	display: flex;
	align-items: center;
	text-decoration: none;
}

.nav-links li a .link-name {
	font-size: 18px;
	font-weight: 400;
	color: #fff;
}

.sidebar.close .nav-links li a .link-name {
	opacity: 0;
	pointer-events: none;
}

.nav-links li .sub-menu {
	padding: 6px 6px 14px 80px;
	margin-top: -10px;
	// background: #36429e;
	// background: rgb(137, 194, 217);
	// background: linear-gradient(
	// 	175deg,
	// 	rgba(137, 194, 217, 1) 0%,
	// 	rgba(76, 161, 175, 1) 50%
	// );
	display: none;
}

.nav-links li.showMenu .sub-menu {
	display: block;
}

.sub-menu li a {
	color: #fff;
	font-size: 15px;
	padding: 5px 0;
	white-space: nowrap;
	opacity: 0.8;
	transition: all 0.3 ease;
}

.sub-menu li a:hover {
	opacity: 1;
}

.sidebar.close .nav-links li .sub-menu {
	position: absolute;
	left: 100%;
	top: -10px;
	margin-top: 0;
	padding: 10px 20px;
	border-radius: 0 6px 6px 0;
	opacity: 0;
	display: block;
	pointer-events: none;
	transition: 0s;
}

.sidebar.close .nav-links li:hover .sub-menu {
	top: 0;
	opacity: 1;
	pointer-events: auto;
}

.sidebar .nav-links li .sub-menu .link-name {
	display: none;
}

.sidebar.close .nav-links li .sub-menu .link-name {
	display: none;
}

.sidebar.close .nav-links li .sub-menu .link-name {
	font-size: 18px;
	opacity: 1;
	display: block;
}

.sidebar .nav-links li .sub-menu.blank {
	opacity: 1;
	pointer-events: auto;
	padding: 3px 20px 6px 6px;
	opacity: 0;
	pointer-events: none;
}

.sidebar .nav-links li:hover .sub-menu.blank {
	top: 50%;
	transform: translateY(-50%);
}

.badge {
	position: absolute;
	right: 5px;
	top: -1px;
	color: #fff;
}
</style>
